import { Component, Input, OnInit } from '@angular/core';
import { BookingStatus } from 'src/app/constants/global-constants';
import { IBookingRequest, IBookingRequestResponse, IDashboardMidwifePayload } from 'src/app/models/dashboard.models';
import { DashboardService } from 'src/app/services/dashboard.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-appointment-requests',
  templateUrl: './appointment-requests.component.html',
  styleUrls: ['./appointment-requests.component.scss']
})
export class AppointmentRequestsComponent implements OnInit {

  @Input() dashboard: IDashboardMidwifePayload;
  bookingRequests: Array<IBookingRequest> = [];
  bookingStatus = BookingStatus;
  selectedBooking: IBookingRequest;

  constructor(public dashboardService: DashboardService,
    private snackBar:SnackbarService) { }

  ngOnInit(): void {
    this.bookingRequests = this.dashboard.bookingRequests;
    this.bookingRequests = this.bookingRequests.filter((res)=>{
      return res.status == this.bookingStatus.REQUESTED ? true : false;
    });
  }

  declineRequest(booking: IBookingRequest){
    let body = {
      requestId: booking.requestId
    }

    this.dashboardService.declineBookingRequest(body)
    .subscribe((res: IBookingRequestResponse)=>{
      this.bookingRequests = this.bookingRequests.filter(book=>{
        return book.requestId != res.payload.requestId ? true : false;
      });
      this.snackBar.openSnackBar("Booking Request Denied !");
      console.log("Booking Request Denied !",res);
    },err=>{
      console.error("Booking Request Deny Failed:", err);
    });
  }

  selectBooking(booking: IBookingRequest){
    this.selectedBooking = booking;
  }

  bookingApproved(requestId: number){
    this.bookingRequests = this.bookingRequests.filter(book=>{
      return book.requestId != requestId ? true : false;
    });
  }
}
